import React from "react";
import { Users, Target, BookOpen, Award, ChevronRight } from "lucide-react";
import { Link } from "react-router-dom";
import Founder from "./Founder";
import BackgroundWrapper from "../components/BackgroundWrapper";

export default function WhoWeAre() {
  return (
       <BackgroundWrapper>
            
      <div className="pt-8 pb-20 px-4 min-h-screen flex justify-center">
              <div className="max-w-5xl bg-white/90 backdrop-blur-md rounded-3xl shadow-2xl p-4 md:p-8">
                <Link
                  to="/"
                  className="mb-8 inline-flex items-center text-blue-600 hover:text-blue-700 font-semibold text-sm sm:text-base"
                >
                   ← Back to Home
                </Link>
          <div className="bg-white/90 backdrop-blur-md rounded-2xl sm:rounded-3xl shadow-2xl px-2 py-4 sm:p-8 md:p-12">
            <h1 className="text-3xl sm:text-4xl md:text-5xl font-bold text-slate-800 mb-6 sm:mb-8 text-center">
              Who We Are
            </h1>

            <p className="text-base sm:text-lg text-slate-700 mb-4 sm:mb-6 leading-relaxed">
              Established in <strong>2013</strong>, our consulting practice is built on 
              decades of experience in <strong>leadership and management consulting</strong>.
            </p>

            <p className="text-base sm:text-lg text-slate-700 mb-8 sm:mb-10 md:mb-12 leading-relaxed">
              We focus on developing <strong>enlightened leaders</strong> and 
              <strong> effective organizations</strong> that are navigating transformation 
              or disruption — going beyond what business schools and tools have to offer.
            </p>

            <div className="grid md:grid-cols-2 gap-6 sm:gap-8 md:gap-12 items-start md:items-center">
              <div className="grid grid-cols-2 gap-4 sm:gap-6">
                <div className="bg-gradient-to-br from-blue-50 to-indigo-50 p-2 sm:p-6 rounded-xl sm:rounded-2xl shadow-lg">
                  <Users className="w-8 sm:w-10 h-8 sm:h-10 text-blue-600 mb-3 sm:mb-4" />
                  <h3 className="font-semibold text-slate-800 mb-1 sm:mb-2 text-sm sm:text-base">
                    Expert Leadership
                  </h3>
                  <p className="text-xs sm:text-sm text-slate-600">
                    Decades of consulting experience
                  </p>
                </div>
                <div className="bg-gradient-to-br from-indigo-50 to-purple-50 p-2 sm:p-6 rounded-xl sm:rounded-2xl shadow-lg">
                  <Target className="w-8 sm:w-10 h-8 sm:h-10 text-indigo-600 mb-3 sm:mb-4" />
                  <h3 className="font-semibold text-slate-800 mb-1 sm:mb-2 text-sm sm:text-base">
                    Transformational Focus
                  </h3>
                  <p className="text-xs sm:text-sm text-slate-600">
                    Beyond traditional methods
                  </p>
                </div>
                <div className="bg-gradient-to-br from-purple-50 to-pink-50 p-2 sm:p-6 rounded-xl sm:rounded-2xl shadow-lg">
                  <BookOpen className="w-8 sm:w-10 h-8 sm:h-10 text-purple-600 mb-3 sm:mb-4" />
                  <h3 className="font-semibold text-slate-800 mb-1 sm:mb-2 text-sm sm:text-base">
                    Tailored Programs
                  </h3>
                  <p className="text-xs sm:text-sm text-slate-600">
                    Customized to your needs
                  </p>
                </div>
                <div className="bg-gradient-to-br from-pink-50 to-red-50 p-2 sm:p-6 rounded-xl sm:rounded-2xl shadow-lg">
                  <Award className="w-8 sm:w-10 h-8 sm:h-10 text-pink-600 mb-3 sm:mb-4" />
                  <h3 className="font-semibold text-slate-800 mb-1 sm:mb-2 text-sm sm:text-base">
                    Accredited
                  </h3>
                  <p className="text-xs sm:text-sm text-slate-600">
                    ICF certified coaching
                  </p>
                </div>
              </div>

              <div className="flex flex-col justify-center">
                <p className="text-base sm:text-lg text-slate-700 mb-6 sm:mb-8 leading-relaxed">
                  Our team combines global expertise with a deep understanding of 
                  human and organizational behavior to foster leadership excellence.
                </p>
                <div className="text-right">
  <Link
    to="/Founder"
    className="text-blue-600 font-semibold hover:text-blue-700 transition-colors text-base sm:text-lg inline-flex items-center w-fit"
  >
    Meet the Founder <ChevronRight className="w-5 h-5 ml-1" />
  </Link>
</div>

              </div>
            </div>
          </div>
        </div>
      </div>
   
</BackgroundWrapper>
  );
}